import { render, staticRenderFns } from "./ModalPromoCodeList.vue?vue&type=template&id=2fe8ca0f&"
import script from "./ModalPromoCodeList.vue?vue&type=script&lang=js&"
export * from "./ModalPromoCodeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports